import { lazy } from 'react';

export const ActivePage = lazy(() => import('./ActivePage'));
